import { createStore } from 'vuex'
import { createCoreServices } from '@/services/coreService';
import { createUserServices } from '@/services/userService';

export default createStore({
  state: {
    user: null,
    tokens: null,
    study: null,
    isLoading: false,
    isAppLoaded: false,
    activeRoute: '/',
  },
  mutations: {
    resetState(state) {
      state.user = null;
      state.isAppLoaded = false;
    },
    setUser(state, user) {
      state.user = user;
    },
    setTokens(state, tokens) {
      state.tokens = tokens;
    },
    setStudy(state, study) {
      state.study = study;
    },
    setLoading(state, isLoading) {
      state.isLoading = isLoading;
    },
    setAppLoaded(state) {
      state.isAppLoaded = true;
    },
    setActiveRoute(state, route) {
      state.activeRoute = route;
    }
  },
  actions: {
    resetState({ commit }) {
      commit('resetState');
    },
    setUser({ commit }, user) {
      commit('setUser', user);
    },
    setTokens({ commit }, tokens) {
      commit('setTokens', tokens);
    },
    setStudy({ commit }, study) {
      commit('setStudy', study);
    },
    setLoading({ commit }, isLoading) {
      commit('setLoading', isLoading);
    },
    setAppLoaded({ commit }) {
      commit('setAppLoaded');
    },
    /**
     * Confirm the stored access token still identifies a user.
     *
     * Deliberately does not navigate: `router/index.js` imports this store, so
     * importing the router here would be a circular dependency. The rejection
     * is returned to the caller, which owns the redirect (see App.vue).
     */
    validateToken({ commit }) {
      const coreServicesInstance = createCoreServices();
      const userServicesInstance = createUserServices(coreServicesInstance);
      return userServicesInstance.getMe().then(response => {
        commit('setUser', response.data);
        commit('setAppLoaded');
      }).catch(error => {
        console.error('Token validation failed', error);
        throw error;
      });
    },
    updateActiveRoute({ commit }, route) {
      commit('setActiveRoute', route);
    }
  },
  getters: {
    user: state => state.user,
    tokens: state => state.tokens,
    study: state => state.study,
    isLoading: state => state.isLoading,
    isUserLoggedIn: state => !!state.user,
    isAppLoaded: state => state.isAppLoaded,
    activeRoute: state => state.activeRoute
  }
});